/* eslint-disable import/prefer-default-export */
import moment from 'moment-timezone';

export const getContractDateLabel = (isoDateString: string, timezone = 'UTC'): string => moment(isoDateString).tz(timezone).format('LL');
